var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-wrapper"},[(_vm.tab_switch == 'staff')?_c('StaffUsers',{on:{"tab":_vm.switchTab}}):_vm._e(),(_vm.tab_switch == 'customer')?_c('CustomerUser',{on:{"tab":_vm.switchTab}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }